import { useEffect, useState } from "react";
import { useAuth, Show } from "@clerk/react";
import { Navigate } from "react-router-dom";
import { makeApi } from "@/api";
import { TrackCard } from "@/components/TrackViews";

function Library() {
  const { getToken } = useAuth();
  const api = makeApi(getToken);
  const [likes, setLikes] = useState([]);
  const [tab, setTab] = useState("likes");
  const [mine, setMine] = useState([]);

  useEffect(() => {
    api.get("/me/likes").then(r => setLikes(r.data)).catch(() => {});
    api.get("/me/tracks").then(r => setMine(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const data = tab === "likes" ? likes : mine;
  return (
    <div className="player-space px-4 md:px-10 py-12">
      <div className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-red-500 mb-3">Library</div>
      <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter uppercase leading-[0.9]">Your Collection</h1>

      <div className="flex gap-6 mt-10 border-b border-neutral-900 pb-3">
        {[["likes", "Liked"], ["mine", "Your Releases"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)}
                  className={`font-mono-ui text-[11px] uppercase tracking-[0.25em] pb-2 border-b-2 transition-colors ${tab === k ? "border-red-600 text-white" : "border-transparent text-neutral-500 hover:text-white"}`}
                  data-testid={`library-tab-${k}`}>
            {l} ({k === "likes" ? likes.length : mine.length})
          </button>
        ))}
      </div>

      {data.length === 0 ? (
        <div className="font-editorial text-2xl text-neutral-500 mt-16">
          {tab === "likes" ? "No favourites yet. Go find something you love." : "No releases yet. Press one to vinyl."}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10 mt-10">
          {data.map(t => <TrackCard key={t.id} track={t} list={data} />)}
        </div>
      )}
    </div>
  );
}

export default function LibraryPage() {
  return (
    <>
      <Show when="signed-in"><Library /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}
